import React, { useState } from "react";
import { Link } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);

  const handleMouseEnter = () => {
    setAboutDropdown(true);
  };

  const handleMouseLeave = () => {
    setAboutDropdown(false);
  };

  const handleDropdownClick = () => {
    setAboutDropdown(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-white border-b border-gray-200 shadow-sm z-50">
      <div className="container mx-auto flex justify-between items-center py-3 px-8">
        {/* Branding/Logo */}
        <div className="flex items-center space-x-2">
          <span className="text-xl font-bold text-gray-900 tracking-tight">Oriri Africa Fund</span>
        </div>
        {/* Hamburger menu for mobile */}
        <button
          className="md:hidden text-gray-900 focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        {/* Navigation Links (desktop) */}
        <ul className="hidden md:flex items-center space-x-8"> {/* <-- add items-center here */}
          <li>
            <Link to="/" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900 hover:border-b-2 hover:border-gray-900 transition duration-200">Home</Link>
          </li>
          {/* About Us with dropdown - now next to Home */}
          <li
            className="relative flex items-center"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/about" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900 flex items-center">
              About Us
              <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </Link>
            {aboutDropdown && (
              <ul
                className="absolute left-0 mt-20 w-40 bg-white border border-gray-300 shadow-md z-50"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <li>
                  <Link
                    to="/team"
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition duration-200"
                    onClick={handleDropdownClick}
                  >
                    Meet the Team
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/challenges" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900 hover:border-b-2 hover:border-gray-900 transition duration-200">Challenge</Link>
          </li>
          <li>
            <Link to="/products" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900 hover:border-b-2 hover:border-gray-900 transition duration-200">Solution</Link>
          </li>
          <li>
            <Link to="/contact" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900 hover:border-b-2 hover:border-gray-900 transition duration-200">Contact</Link>
          </li>
        </ul>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <ul className="md:hidden flex flex-col items-center space-y-4 py-4 bg-white border-t border-gray-200">
          <li>
            <Link to="/" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900" onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to="/challenges" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900" onClick={() => setMenuOpen(false)}>Challenge</Link>
          </li>
          <li>
            <Link to="/products" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900" onClick={() => setMenuOpen(false)}>Solution</Link>
          </li>
          {/* About Us with dropdown for mobile */}
          <li>
            <Link to="/about" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900" onClick={() => setMenuOpen(false)}>About Us</Link>
            <ul>
              <li>
                <Link to="/team" className="block px-4 py-2 text-gray-700 hover:text-gray-900 transition duration-200" onClick={() => setMenuOpen(false)}>
                  Meet the Team
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/contact" className="px-4 py-2 text-gray-700 font-medium hover:text-gray-900" onClick={() => setMenuOpen(false)}>Contact</Link>
          </li>
        </ul>
      )}
    </nav>
  );
}

export default Navbar;